/**
 * Storage IndexedDB com persistência atômica (sem clear+rewrite no store active).
 */

import type { QueueItem } from '../queue/types';
import type { IQueueStorage, StorageHealth } from './IQueueStorage';
import { commitQueueSnapshot, loadActiveQueueItems } from './shadowCommit';
import { idbDelete, idbPut } from './idbQueueDb';
import { STORE_ITEMS } from './idbQueueDb';

export class AtomicIndexedDBQueueStorage implements IQueueStorage {
  readonly name = 'indexeddb';

  async loadAll(): Promise<QueueItem[]> {
    return loadActiveQueueItems();
  }

  async saveAll(items: QueueItem[]): Promise<void> {
    const result = await commitQueueSnapshot(items);
    if (!result.ok) {
      throw new Error('Shadow commit failed');
    }
  }

  async put(item: QueueItem): Promise<void> {
    await idbPut(STORE_ITEMS, item);
  }

  async delete(id: string): Promise<void> {
    await idbDelete(STORE_ITEMS, id);
  }

  async health(): Promise<StorageHealth> {
    const items = await this.loadAll();
    const bytes = new TextEncoder().encode(JSON.stringify(items)).length;
    return {
      ok: true,
      backend: 'indexeddb',
      itemCount: items.length,
      estimatedBytes: bytes,
    };
  }
}
